import { Component, Input, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { DocumentService } from '../../../../../common/services';
import { Document } from '../../../../../common/models';

@Component({
    selector: 'jft-invitation-documents-list',
    templateUrl: './invitation-documents-list.component.html',
    styleUrls: ['./invitation-documents-list.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class InvitationDocumentsListComponent implements OnInit {

    @Input() documents: Document[] = [];
    @Input() readonly: boolean = false;

    constructor(
        protected service: DocumentService
    ) {
    }

    public ngOnInit(): void {

    }

    public download(doc: Document) {
        return this.service.downloadDocument(doc);
    }
}
